var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePickerComponent',{attrs:{"value":_vm.value,"format":_vm.$dateFormatInput.split(' ')[0],"floatLabelType":_vm.floatLabel ? 'Always' : 'Never',"placeholder":_vm.placeholder,"showClearButton":false,"cssClass":"partner-console__ejs-datepicker"},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }